import Card from "@material-ui/core/Card";
import InputBase from "@material-ui/core/InputBase";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import withStyles from "@material-ui/core/styles/withStyles";
import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import { fetchInitData, getAnimeInfoListData } from "./logic";
import { AnimeCool, AnimeInfo, AnimeInfos } from './type';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    cardInfoErea: {
        padding: '20px',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat( auto-fill, minmax(270px,1fr) )',
        gridGap: '30px',
        justifyContent: 'center',
        backgroundColor: '#F0FFF4',
    },
    card: {
        height: 535,
        width: 270,
        display: 'grid',
        gridGap: '5px',
        gridAutoRows: '380px 150px',
        placeItems: 'center',
        margin: '0 auto',
    },
    cardInfo: {
        height: 150,
        width: 270,
        padding: '0px 10px',
    },
    link: {
        display: 'block',
        margin: 'auto',
    },
    img: {
        display: 'block',
        margin: 'auto',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
});

const BootstrapInput = withStyles(() => ({
    input: {
        borderRadius: 4,
        border: '1px solid #ced4da',
        padding: '10px 26px 10px 12px',
        '&:focus': {
            borderRadius: 4,
            // borderColor: '#80bdff',
            // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

function Page(): ReactElement {
    const classes = useStyles();
    const [pulldownlist, setPullDownlist] = useState<AnimeCool[]>([])
    const [animeInfoList, setAnimeInfoList] = useState<AnimeInfos[]>([])
    const [pulldown, setPullDown] = useState('1')

    useEffect(() => {
        fetchInitData(setPullDownlist, setAnimeInfoList, setPullDown)
    }, [])

    console.log("pulldown", pulldown)

    const changepullDown = (value: string) => {
        const animecool = pulldownlist.find((pulldown) => pulldown.id.toString() === value)
        console.log("animecool", animecool, value, pulldownlist)
        if (!animecool) {

            return
        }
        console.log("data", animecool)
        getAnimeInfoListData(setAnimeInfoList, animecool);
        setPullDown(value)
    }

    return (
        <div>
            <Select
                style={{ width: "150px", height: "45px", margin: '5px auto 0 auto', display: 'block', textAlign: "center" }}
                defaultValue={pulldown}
                value={pulldown}
                onChange={(e) => changepullDown(String(e.target.value))}
                input={<BootstrapInput />}
            >
                {pulldownlist.map(pulldown => (
                    <MenuItem style={{ height: "35px" }} value={pulldown.id}>{pulldown.year}/{pulldown.cours}</MenuItem>
                ))}
            </Select>
            <div className={classes.cardInfoErea}>
                {animeInfoList && animeInfoList?.map(animeInfo => (
                    <Card className={classes.card} key={animeInfo.id}>
                        {/* <a href={animeInfo.amazon_url} target="_blank" rel="noreferrer noopener"> */}
                        <a href={animeInfo.amazon_url} target="_blank" rel="noreferrer noopener">
                            <img className={classes.img} src={animeInfo.amazon_img_src} alt={animeInfo.title} />
                        </a>
                        <Card>
                            <ul className={classes.cardInfo}>
                                <li><a href={animeInfo.public_url} target="_blank" rel="noreferrer noopener">{animeInfo.title}</a></li>
                                <li>{animeInfo.product_companies}</li>
                                <li>{animeInfo.city_name}</li>
                            </ul>
                        </Card>
                    </Card>
                ))}
            </div>

        </div>
    )
}

function parent() {
    return (
        <div>
            <Page />
        </div>
    )

}

export default parent;